//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export class Resource
{
	public static about: string = `About`;
	public static aboutScrapers: string = `AboutScrapers`;
	public static accessDenied: string = `AccessDenied`;
	public static addNewScraperRecommendation: string = `AddNewScraperRecommendation`;
	public static addNewWatchdogRecommendation: string = `AddNewWatchdogRecommendation`;
	public static addWebPageToScrape: string = `AddWebPageToScrape`;
	public static advanced: string = `Advanced`;
	public static archived: string = `Archived`;
	public static author: string = `Author`;
	public static back: string = `Back`;
	public static calculatedEarningsForThisMonth: string = `CalculatedEarningsForThisMonth`;
	public static cancel: string = `Cancel`;
	public static contactSupport: string = `ContactSupport`;
	public static copyright: string = `Copyright`;
	public static create: string = `Create`;
	public static createScraper: string = `CreateScraper`;
	public static createWatchdog: string = `CreateWatchdog`;
	public static deleteScraper: string = `DeleteScraper`;
	public static deleteScraperConfirmationMessage: string = `DeleteScraperConfirmationMessage`;
	public static deleteWatchdog: string = `DeleteWatchdog`;
	public static deleteWatchdogConfirmationMessage: string = `DeleteWatchdogConfirmationMessage`;
	public static deleteWebPage: string = `DeleteWebPage`;
	public static description: string = `Description`;
	public static edit: string = `Edit`;
	public static email: string = `Email`;
	public static emailAddressRegexAttribute: string = `EmailAddressRegexAttribute`;
	public static enableWebPage: string = `EnableWebPage`;
	public static error: string = `Error`;
	public static errorDescription: string = `ErrorDescription`;
	public static errorMessage: string = `ErrorMessage`;
	public static filterResults: string = `FilterResults`;
	public static finish: string = `Finish`;
	public static here: string = `Here`;
	public static homePage: string = `HomePage`;
	public static httpHeaders: string = `HttpHeaders`;
	public static invalidHttpHeaderFormatErrorTemplate: string = `InvalidHttpHeaderFormatErrorTemplate`;
	public static listOfScrapers: string = `ListOfScrapers`;
	public static loginLinkEmailBody: string = `LoginLinkEmailBody`;
	public static loginLinkEmailSubject: string = `LoginLinkEmailSubject`;
	public static loginLinkSent: string = `LoginLinkSent`;
	public static loginLinkSentDescription: string = `LoginLinkSentDescription`;
	public static loginOr: string = `LoginOr`;
	public static loginOrRegister: string = `LoginOrRegister`;
	public static loginOrRegisterToCreateWatchdog: string = `LoginOrRegisterToCreateWatchdog`;
	public static loginWithEmail: string = `LoginWithEmail`;
	public static loginWithGoogle: string = `LoginWithGoogle`;
	public static logout: string = `Logout`;
	public static makePrivate: string = `MakePrivate`;
	public static makePublic: string = `MakePublic`;
	public static makeScraperPrivateConfirmationMessage: string = `MakeScraperPrivateConfirmationMessage`;
	public static makeScraperPublicConfirmationMessage: string = `MakeScraperPublicConfirmationMessage`;
	public static manageOtherUsersScrapersDescription: string = `ManageOtherUsersScrapersDescription`;
	public static manageScraper: string = `ManageScraper`;
	public static manageScrapers: string = `ManageScrapers`;
	public static manageUserScrapersDescription: string = `ManageUserScrapersDescription`;
	public static mrWatchdog: string = `MrWatchdog`;
	public static myScraper: string = `MyScraper`;
	public static myScrapers: string = `MyScrapers`;
	public static myScrapersDescription: string = `MyScrapersDescription`;
	public static myScraperTooltip: string = `MyScraperTooltip`;
	public static myWatchdogs: string = `MyWatchdogs`;
	public static myWatchdogsDescription: string = `MyWatchdogsDescription`;
	public static name: string = `Name`;
	public static navigateToThe: string = `NavigateToThe`;
	public static needHelp: string = `NeedHelp`;
	public static newScrapedResultsEmailBody: string = `NewScrapedResultsEmailBody`;
	public static newScrapedResultsEmailSubject: string = `NewScrapedResultsEmailSubject`;
	public static next: string = `Next`;
	public static noHtmlNodesSelected: string = `NoHtmlNodesSelected`;
	public static noScrapedResultsAvailable: string = `NoScrapedResultsAvailable`;
	public static noScrapedResultsMatchingTheSearchTermAvailable: string = `NoScrapedResultsMatchingTheSearchTermAvailable`;
	public static numberOfDaysBetweenNotificationsForTheSameScrapedResult: string = `NumberOfDaysBetweenNotificationsForTheSameScrapedResult`;
	public static numberOfFailedScrapingAttemptsBeforeAlerting: string = `NumberOfFailedScrapingAttemptsBeforeAlerting`;
	public static numberOfUsersWithWatchdogWithEmailNotification: string = `NumberOfUsersWithWatchdogWithEmailNotification`;
	public static numberOfUsersWithWatchdogWithoutEmailNotification: string = `NumberOfUsersWithWatchdogWithoutEmailNotification`;
	public static ok: string = `Ok`;
	public static onboardingViewAgainStep: string = `OnboardingViewAgainStep`;
	public static optionalLocalizationJsonFormat: string = `OptionalLocalizationJsonFormat`;
	public static pleaseEnableItOnceYourEditsAreComplete: string = `PleaseEnableItOnceYourEditsAreComplete`;
	public static privateStatus: string = `PrivateStatus`;
	public static privateStatusTooltip: string = `PrivateStatusTooltip`;
	public static publicScrapers: string = `PublicScrapers`;
	public static publicScrapersDescription: string = `PublicScrapersDescription`;
	public static publicStatus: string = `PublicStatus`;
	public static publicStatusTooltip: string = `PublicStatusTooltip`;
	public static rangeAttribute: string = `RangeAttribute`;
	public static receiveEmailNotificationAboutNewResults: string = `ReceiveEmailNotificationAboutNewResults`;
	public static removeWebPageConfirmationMessage: string = `RemoveWebPageConfirmationMessage`;
	public static requestedToBeMadePublicStatus: string = `RequestedToBeMadePublicStatus`;
	public static requestedToBeMadePublicStatusTooltip: string = `RequestedToBeMadePublicStatusTooltip`;
	public static requestId: string = `RequestId`;
	public static requestToMakePublic: string = `RequestToMakePublic`;
	public static requestToMakeScraperPublicConfirmationMessage: string = `RequestToMakeScraperPublicConfirmationMessage`;
	public static requiredAttribute: string = `RequiredAttribute`;
	public static save: string = `Save`;
	public static scrapedOn: string = `ScrapedOn`;
	public static scrapedResults: string = `ScrapedResults`;
	public static scrapedResultsFilteringNotSupported: string = `ScrapedResultsFilteringNotSupported`;
	public static scrapeHtmlAsRenderedByBrowser: string = `ScrapeHtmlAsRenderedByBrowser`;
	public static scrapeHtmlAsRenderedByBrowserHint: string = `ScrapeHtmlAsRenderedByBrowserHint`;
	public static scraperCreateOnboardingSetName: string = `ScraperCreateOnboardingSetName`;
	public static scraperDetailOnboardingAddWebPage: string = `ScraperDetailOnboardingAddWebPage`;
	public static scraperDetailOnboardingIntro: string = `ScraperDetailOnboardingIntro`;
	public static scraperDetailOnboardingRequestToMakePublic: string = `ScraperDetailOnboardingRequestToMakePublic`;
	public static scraperDetailOnboardingScrapingInterval: string = `ScraperDetailOnboardingScrapingInterval`;
	public static scraperDetailOnboardingViewScrapedResults: string = `ScraperDetailOnboardingViewScrapedResults`;
	public static scraperEarningsCalculationInfo: string = `ScraperEarningsCalculationInfo`;
	public static scraperResultsOnboardingCreateWatchdog: string = `ScraperResultsOnboardingCreateWatchdog`;
	public static scraperResultsOnboardingIntro: string = `ScraperResultsOnboardingIntro`;
	public static scraperResultsOnboardingLoginOrRegisterToCreateWatchdog: string = `ScraperResultsOnboardingLoginOrRegisterToCreateWatchdog`;
	public static scraperResultsOnboardingSearchTerm: string = `ScraperResultsOnboardingSearchTerm`;
	public static scraperResultsOnboardingWatchedWebPages: string = `ScraperResultsOnboardingWatchedWebPages`;
	public static scrapers: string = `Scrapers`;
	public static scrapeWebPage: string = `ScrapeWebPage`;
	public static scrapingByBrowserWaitFor: string = `ScrapingByBrowserWaitFor`;
	public static scrapingByBrowserWaitForDomContentLoaded: string = `ScrapingByBrowserWaitForDomContentLoaded`;
	public static scrapingByBrowserWaitForLoad: string = `ScrapingByBrowserWaitForLoad`;
	public static scrapingByBrowserWaitForNetworkIdle: string = `ScrapingByBrowserWaitForNetworkIdle`;
	public static scrapingIntervalInSeconds: string = `ScrapingIntervalInSeconds`;
	public static selector: string = `Selector`;
	public static selectTextInsteadOfHtml: string = `SelectTextInsteadOfHtml`;
	public static statusCode: string = `StatusCode`;
	public static stringLengthAttribute: string = `StringLengthAttribute`;
	public static support: string = `Support`;
	public static thereAreNoPublicScrapers: string = `ThereAreNoPublicScrapers`;
	public static theWebPageHasBeenAutomaticallyDisabled: string = `TheWebPageHasBeenAutomaticallyDisabled`;
	public static toEnableItMakeSureTheWebPageIsSuccessfullyScraped: string = `ToEnableItMakeSureTheWebPageIsSuccessfullyScraped`;
	public static unsubscribe: string = `Unsubscribe`;
	public static unsubscribedFromWatchdogEmailNotification: string = `UnsubscribedFromWatchdogEmailNotification`;
	public static url: string = `Url`;
	public static urlAttribute: string = `UrlAttribute`;
	public static viewScrapedResults: string = `ViewScrapedResults`;
	public static watchdogArchivedEmailBody: string = `WatchdogArchivedEmailBody`;
	public static watchdogArchivedEmailSubject: string = `WatchdogArchivedEmailSubject`;
	public static watchdogOnboardingIntro: string = `WatchdogOnboardingIntro`;
	public static watchdogOnboardingIntroScrapedResults: string = `WatchdogOnboardingIntroScrapedResults`;
	public static watchdogOnboardingIntroSearchTerm: string = `WatchdogOnboardingIntroSearchTerm`;
	public static watchdogOnboardingReceiveNotification: string = `WatchdogOnboardingReceiveNotification`;
	public static watchedWebPages: string = `WatchedWebPages`;
	public static webPageNotScrapedYet: string = `WebPageNotScrapedYet`;
	public static webScrapingFailedEmailBody: string = `WebScrapingFailedEmailBody`;
	public static webScrapingFailedEmailSubject: string = `WebScrapingFailedEmailSubject`;
	public static youCanCreateScraperAndLaterMakeItPublic: string = `YouCanCreateScraperAndLaterMakeItPublic`;
	public static youHaveBeenLoggedIn: string = `YouHaveBeenLoggedIn`;
	public static youHaveBeenLoggedInDescription: string = `YouHaveBeenLoggedInDescription`;
	public static youHaveBeenLoggedInDescriptionContinueHere: string = `YouHaveBeenLoggedInDescriptionContinueHere`;
	public static youHaveNoScrapersCreated: string = `YouHaveNoScrapersCreated`;
	public static youHaveNoWatchdogs: string = `YouHaveNoWatchdogs`;
}
